const {
  blockEditor: { useBlockProps, useInnerBlocksProps },
} = wp;

const DEFAULT_TAB_SLIDER_TAB_CONTENT_TEMPLATE = [
  [
    'core/paragraph',
    {
      placeholder: 'Tab content ...',
    },
  ],
];

const Edit = () => {
  const blockProps = useBlockProps();
  const { children, ...innerBlockProps } = useInnerBlocksProps(blockProps, {
    template: DEFAULT_TAB_SLIDER_TAB_CONTENT_TEMPLATE,
  });

  return (
    <>
      <div {...innerBlockProps}>{children}</div>
    </>
  );
};

export default Edit;
